import { Box, Button, Modal, Typography } from "@mui/material";
import { useState } from "react";

const ShowNotesModal = (props:{'data':string,'name':string,'date':string}) => {

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    };

    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

  return (
    <div>
      <Button onClick={handleOpen}>לצפייה</Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            הערות לאימון {props.name} - {props.date}
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            {props.data}
          </Typography>
        </Box>
      </Modal>
    </div>
  );
}
export default ShowNotesModal